/* Velvet Vogue - product gallery: blurred photo fill behind each photo (no empty side bars) + thin swipe bar instead of dots. */
(function () {
  'use strict';
  var GAP = 4;
  function mk(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  /* ---- blurred backdrop: a tiny copy of the same photo, blurred by CSS ---- */
  function tiny(src) {
    if (!/^(https?:)?\/\//.test(src)) return '';
    if (src.indexOf('/cdn/shop/') < 0) return src;
    var q = src.indexOf('?'), base = q < 0 ? src : src.slice(0, q), qs = q < 0 ? '' : src.slice(q + 1);
    qs = qs.split('&').filter(function (p) { return p && !/^(width|height|crop)=/.test(p); });
    qs.push('width=80');
    return base + '?' + qs.join('&');
  }
  function setBg(img) {
    var pm = img.closest('.product-media'); if (!pm) return;
    var src = img.currentSrc || img.getAttribute('src') || ''; if (!src) return;
    var t = tiny(src); if (!t || pm.getAttribute('data-vvbg') === t) return;
    pm.setAttribute('data-vvbg', t);
    pm.style.setProperty('--vv-bg', 'url(' + JSON.stringify(t) + ')');
  }
  function backdrops() {
    var imgs = document.querySelectorAll('.product-information .hk-mobile-loop-gallery .product-media img, .product-information .hk-native-product-gallery .product-media img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        setBg(img);
        if (!img.complete && !img.__vvl) { img.__vvl = 1; img.addEventListener('load', function () { setBg(img); }); }
      })(imgs[i]);
    }
  }

  /* ---- swipe bar: the dark segment follows the finger while swiping ---- */
  function update(g) {
    var track = g.querySelector('.hk-mobile-loop-gallery__track'), bar = g.querySelector(':scope > .vv-gbar');
    if (!track || !bar) return;
    var n = +bar.getAttribute('data-n'), th = bar.lastChild, W = bar.clientWidth;
    var slides = track.querySelectorAll('[data-hk-loop-slide]');
    if (!W || !slides.length) return;
    var sw = slides[0].getBoundingClientRect().width || track.clientWidth; if (!sw) return;
    var seg = (W - GAP * (n - 1)) / n;
    var p = track.scrollLeft / sw, lo = Math.floor(p + 0.001), f = p - lo; if (f < 0.002) f = 0;
    var a = slides[lo], b = slides[lo + 1];
    var ia = a ? +a.getAttribute('data-real-index') : 0, ib = b ? +b.getAttribute('data-real-index') : ia, r;
    if (!b || f === 0) r = ia;
    else if (Math.abs(ib - ia) === 1) r = ia + (ib - ia) * f;
    else r = (a.getAttribute('data-clone') === 'last') ? ib : ia;
    if (isNaN(r)) r = 0;
    r = Math.max(0, Math.min(n - 1, r));
    th.style.width = seg + 'px';
    th.style.transform = 'translateX(' + (r * (seg + GAP)) + 'px)';
  }
  function bars() {
    var gs = document.querySelectorAll('.product-information hk-loop-gallery.hk-mobile-loop-gallery');
    for (var k = 0; k < gs.length; k++) {
      (function (g) {
        var track = g.querySelector('.hk-mobile-loop-gallery__track'); if (!track) return;
        var n = parseInt(g.getAttribute('data-count'), 10) || g.querySelectorAll('[data-hk-loop-dot]').length;
        var bar = g.querySelector(':scope > .vv-gbar');
        if (!n || n < 2) { if (bar) bar.remove(); return; }
        if (!bar || +bar.getAttribute('data-n') !== n) {
          if (bar) bar.remove();
          bar = mk('div', 'vv-gbar'); bar.setAttribute('data-n', n); bar.setAttribute('aria-hidden', 'true');
          for (var i = 0; i < n; i++) bar.appendChild(mk('i'));
          bar.appendChild(mk('span', 'vv-gbar__thumb'));
          g.appendChild(bar);
        }
        if (g.__vvTrack !== track) {
          g.__vvTrack = track;
          track.addEventListener('scroll', function () { update(g); }, { passive: true });
        }
        update(g);
      })(gs[k]);
    }
  }

  var sched = 0;
  function scan() { if (sched) return; sched = setTimeout(function () { sched = 0; backdrops(); bars(); }, 100); }
  function init() {
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', function () { var gs = document.querySelectorAll('hk-loop-gallery.hk-mobile-loop-gallery'); for (var i = 0; i < gs.length; i++) update(gs[i]); });
    window.addEventListener('load', scan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
